import { UiComponents } from "@simulanisindia/ui";
import { useSelector } from "react-redux";

const { IconButton, SimTooltip, SimToggleSwitch, SimDropdownBasic, SimCheckBox } = UiComponents;

const SelectionLine_N = ({
  handleSelectCheckBox,
  checkBox,
  activeTab,
  text,
  buttonShow = true,
  className = "",
  isAllSelected = false,
  totalCount = 0,
  onSelectionChange,
  style = {},
  selectedResource,
  handleSelectAllActiveItems,
  handleClearAllActiveItems,
  checkBoxAll,
  loading
}) => {

  const filterOptionData = useSelector((state) => state.filterOptions);

  return (
    <div className="selectionlineparent mt-0" style={style}>
      <div className={`selectionline ${!buttonShow ? "justify-content-center py-3" : ""} ${className}`}>
        <div className="selectionlinebtn">
          {!loading &&
            <div className="checkanddrp d-flex align-items-center gap-2">
              <SimCheckBox
                onChange={(e) => handleSelectCheckBox(e.target.checked)}
                checked={checkBox[activeTab]}
              />
            </div>}

          <p>{checkBox[activeTab] &&
            <>
              {checkBoxAll[activeTab] ?
                <>
                  All {filterOptionData.total[activeTab]} items are selected.
                  <span onClick={() => handleClearAllActiveItems(activeTab)}> Clear all </span>
                </>
                :
                <>
                  {selectedResource[activeTab].length} items are selected.
                  {selectedResource[activeTab].length !== filterOptionData.total[activeTab] && <span onClick={() => handleSelectAllActiveItems(activeTab)}> Select all {filterOptionData.total[activeTab]} items </span>}
                </>
              }
            </>
          }</p>
        </div>
      </div>
    </div>
  );
};

export default SelectionLine_N;